<template>
    <v-display :form="form" :path="path" :label="topLabel" value="" :hide-underline="hideUnderline">
        <q-checkbox v-model="inputValue"
                    :label="bottomLabel | capitalize"
                    :disable="form.busy || disable"
                    checked-icon="fa icon-checkbox"
                    unchecked-icon="fa icon-checkbox-blank"
                    @input="onInput"></q-checkbox>
        <span v-html="extraHtml" style="margin-top: 2px; margin-left: 5px"></span>
    </v-display>
</template>

<script>
    import mixins from './mixins'
    import {QCheckbox} from 'quasar-framework'

    export default {
        name: 'VCheckbox',

        mixins,

        data() {
            return {
                inputValue: this.value ? true : false
            }
        },

        props: {
            innerLabel: String,
            extraHtml: String
        },

        computed: {
            topLabel() {
                return this.innerLabel ? this.label : ''
            },
            bottomLabel() {
                return this.innerLabel || this.label
            },
        },

        components: {
            QCheckbox
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/form/VCheckbox.vue